import RestClient from '@/api/api';

class UsersAPI extends RestClient {
  async getAll() {
    return await this._get(`/users`);
  }

  async getUserDetails(id) {
    return await this._get(`/users/${id}`);
  }
}

export default new UsersAPI();
